export default __webpack_public_path__ + "static/media/logo.dd5f1ca0.png";